import { useQuery } from "@tanstack/react-query";
import { fetchEntity } from "../Dashboard/api";
import type { EntityKind } from "../Dashboard/types";

// Query Keys
export const ENTITY_QUERY_KEYS = {
  entity: (entityKind: EntityKind, entityId: string) =>
    ["rms", "entity", entityKind, entityId] as const,
};

// Entity Query Hook
export const useEntity = (
  entityKind: EntityKind,
  entityId: string,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  return useQuery({
    queryKey: ENTITY_QUERY_KEYS.entity(entityKind, entityId),
    queryFn: () => fetchEntity(entityKind, entityId),
    enabled,
    staleTime: 5 * 1000, // 5 seconds - much shorter to ensure fresh data
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: true, // Refetch on mount if stale
  });
};
